module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "vue-directive-image-previewer",
    staticClass: "vue-directive-image-previewer"
  }, [_c('div', {
    staticClass: "wrapper",
    style: (_vm.wrapperStyle),
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "vue-directive-image-previewer-pic",
    style: ({
      height: _vm.pictureHeight,
      width: _vm.pictureWidth,
      top: _vm.pictureTop,
      left: _vm.pictureLeft
    }),
    attrs: {
      "src": _vm.picture
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55f319f7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/directives/imagePreview/index.vue
// module id = 339
// module chunks = 0